export enum EViewMode {
  SPLIT_SCREEN = 'split-screen',
  SLIDER = 'slider'
}
